/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { PaginatedMainPageTagListAdmin } from './PaginatedMainPageTagListAdmin'
import {
  PaginatedMainPageTagListAdminFromJSON,
  PaginatedMainPageTagListAdminFromJSONTyped,
  PaginatedMainPageTagListAdminToJSON,
} from './PaginatedMainPageTagListAdmin'

/**
 *
 * @export
 * @interface EnvelopedMainPageTagListMainPageTagListAdmin
 */
export interface EnvelopedMainPageTagListMainPageTagListAdmin {
  /**
   *
   * @type {PaginatedMainPageTagListAdmin}
   * @memberof EnvelopedMainPageTagListMainPageTagListAdmin
   */
  body: PaginatedMainPageTagListAdmin
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedMainPageTagListMainPageTagListAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedMainPageTagListMainPageTagListAdmin interface.
 */
export function instanceOfEnvelopedMainPageTagListMainPageTagListAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedMainPageTagListMainPageTagListAdminFromJSON(
  json: any,
): EnvelopedMainPageTagListMainPageTagListAdmin {
  return EnvelopedMainPageTagListMainPageTagListAdminFromJSONTyped(json, false)
}

export function EnvelopedMainPageTagListMainPageTagListAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedMainPageTagListMainPageTagListAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: PaginatedMainPageTagListAdminFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedMainPageTagListMainPageTagListAdminToJSON(
  value?: EnvelopedMainPageTagListMainPageTagListAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: PaginatedMainPageTagListAdminToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
